import { ALU_2K_GLAZY, SLIDY_30, SLIDY_36 } from './glazingWallTypes';

export const SE0026 = 'SE0026';
export const SE0134 = 'SE0134';
export const SE0135 = 'SE0135';
export const SE0204 = 'SE0204';
export const SE0229 = 'SE0229';
export const SHOP_PROFILE = 'Shop Profile';

export const floorProfileTypesByWallTypes = {
  [ALU_2K_GLAZY]: [SE0204],
  [SLIDY_30]: [SE0026, SE0134],
  [SLIDY_36]: [SE0026, SE0134],
};

const floorProfileTypes = [SE0026, SE0134, SE0135, SE0229, SHOP_PROFILE];

export default floorProfileTypes;
